import { InvoiceType } from '@/depreciations/models/invoice-type.enum';

export class DepreciationSettings {
    enableNotifications = false;
    invoiceType = InvoiceType.CODE;
    allowedFileTypes: string[] = [];


    deserialize(data: any): this {
        this.enableNotifications = data.enable_notifications ?? false;
        this.invoiceType = data.invoice_type ?? InvoiceType.CODE;
        this.allowedFileTypes = (data.allowed_file_types ?? []) as string[];
        return this;
    }

    serialize(): any {
        return {
            enable_notifications: this.enableNotifications,
            invoice_type: this.invoiceType,
            allowed_file_types: this.allowedFileTypes,
        };
    }
}
